module.exports = __webpack_public_path__ + "static/media/ic-emoji_hushed_face.d5ce5d09.svg";